import { Channel } from "../Com/Com.Interfaces";
import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { LanguageCode } from "../UnitsAndLocalization/Languages.Interface";
import { ValidMessagePayload } from "./Message.Types";

//LINK libs/entities/src/Message/Message.Entity.ts
export enum MessageType {
  Auth = "Auth",
  Buttons = "Buttons",
  CreateUserAndStartConversation = "CreateUserAndStartConversation",
  StartConversation = "StartConversation",
  Text = "Text",
  ActionTaken = "ActionTaken",
  Typing = "Typing",
  TakeoverEvent = "TakeoverEvent",
  Carousel = "Carousel",
  MultiSelect = "MultiSelect",
  ProfileCollect = "ProfileCollect",
  Media = "Media",
  Command = "Command",
  LocationPicker = "LocationPicker",
  SpacePicker = "Space Picker",
  Voice = "Voice",
  UserShouldMerge = "UserShouldMerge",
}
export const InvisibleMessageTypes: Array<MessageType> = [
  MessageType.Auth,
  MessageType.CreateUserAndStartConversation,
  MessageType.StartConversation,
  MessageType.ActionTaken,
  MessageType.Typing,
  MessageType.Command,
  MessageType.UserShouldMerge,
];

export function isMessageInvisibile(message: MessageInterface): boolean {
  return InvisibleMessageTypes.includes(message.type);
}

export function isMessageType(type: any): type is MessageType {
  return Object.values(MessageType).includes(type);
}

// We might want to subclass the message interface for all the different types of messages. That would let us
// have a constant type safe then we wouldn't have to create 500000 || statments and also maybe than I can just
// Have one simple interface and not even make it a class. Or do I want different classes? I'm not sure...

export enum ActionTakenType {
  Selected = "selected",
  OptionsSelected = "options_selected",
  URLSelected = "url_selected",
  Other = "other",
}

export function isActionTakenType(type: any): type is ActionTakenType {
  return Object.values(ActionTakenType).includes(type);
}

export interface ActionTaken {
  type: ActionTakenType;
  target?: string;
  data?: any;
}

export function isActionTaken(actionTaken: any): actionTaken is ActionTaken {
  return actionTaken !== undefined && (actionTaken as ActionTaken).type !== undefined && isActionTakenType(actionTaken.type);
}
/**
 * @tsoaModel
 */

export enum From {
  USER = "user",
  BOT = "bot",
  AGENT = "agent",
}

export interface MessageTranslationData {
  from?: LanguageCode;
  to?: LanguageCode;
  originalPayload?: ValidMessagePayload; // Only do this if we are translating from english
  translatedPayload?: ValidMessagePayload; // Only do this if we are translating into english
}

// Define the MessageInterface
export interface MessageInterface {
  id?: number;
  uuid: string;
  userId: number;
  orgId: number;
  agentMemberId?: number;
  from: From;
  type: MessageType;
  visible?: boolean; // If this is false, the message is not shown to the user
  actionTaken?: ActionTaken;
  createdAt?: Date; // This number is used in creation of the message
  updatedAt?: Date; // This number is used in creation of the message
  payload: ValidMessagePayload & { text?: string; mediaURL?: string; template?: any; actions?: any[] };
  translation?: MessageTranslationData;
  channel?: Channel;
  sessionId?: number; // This is the session id that this message belongs to.
}
